import React from "react";

import Header from "./Header";
import Footer from "./Footer";
export default () => {
  return (
      <>
        <Header/>
        <main>
            <section class="banner-section position-relative" style={{backgroundImage:`url('assets/img/shape/shape-banner-bg.png')`}}>
                <div class="mkt-container">
                    <div class="banner-content position-relative z-1">
                        <div class="shape-1" style={{backgroundImage:`url('assets/img/shape/shape-1.png')`}}></div>
                        <div class="shape-2" style={{backgroundImage:`url('assets/img/shape/shape-2.png')`}}></div>
                        <h4 class="banner-subtitle">Premium Commercial Real Estate Solutions</h4>
                        <h1 class="banner-title">Specializing in   <br/><span>commercial property leasing </span> <br/>for leading brands expanding <br/>across India</h1>
                        <div class="btn-box">
                            <a href="/#About" class="theme-btn btn-style-one">
                                <span class="txt">Start Your Expansion Journey </span>            
                            </a>
                        </div>
                    </div>
                    <figure class="banner-image">
                        <img style={{width:550}} src="assets/img/banner/527_650.png" alt=""/>
                    </figure>
                </div>
                <div class="shape-4" style={{backgroundImage:`url('assets/img/shape/shape-building.png')`}}></div>
                <div class="shape-5" style={{backgroundImage:`url('assets/img/shape/shape-logo.png')`}}></div>
            </section>

            <section class="choose-section sec-padding">
                <div class="mkt-container">
                    <div class="row g-4">
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon">
                                    <i class="fat fa-laptop-code"></i>
                                </div>
                                <div class="content">
                                    <h4><a href="/#Services">Brand Expansion Partnerships</a></h4>
                                    <p>Exclusive tie-ups with 50+ leading brands</p>
                                    <p>Dedicated support for franchise and flagship store rollouts</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon">
                                    <i class="fat fa-display-chart-up-circle-dollar"></i>
                                </div>
                                <div class="content">
                                    <h4><a href="/#Services">Location Scouting & Market Feasibility</a></h4>
                                    <p>On-ground research in Tier 1 & Tier 2 cities</p>
                                    <p>Footfall assessment and rental benchmarking</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon">
                                    <i class="fat fa-photo-film-music"></i>
                                </div>
                                <div class="content">
                                    <h4><a href="/#Services">Lease Negotiation & Legal Closure</a></h4>
                                    <p>Site visits, landlord coordination, and compliance management</p>
                                    <p>Expert lease drafting & regulatory support</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon">
                                    <i class="fat fa-business-time"></i>
                                </div>
                                <div class="content">
                                    <h4><a href="/#Services">Post-Deal & Property Management </a></h4>
                                    <p>Support with store launch, maintenance, and lease renewals</p>
                                    <p>Tenant-landlord relationship management</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="work-showcase-section" style= {{backgroundImage:`url('assets/img/shape/showcase-bg.png')`}}>
                <div class="mkt-container">
                    <div class="title-box position-relative">
                        <div class="title-shape" style={{backgroundImage:`url('assets/img/shape/title-shape.png')`}}></div>
                        <h4 class="sec-sub-title">Our Recent Projects</h4>
                        <h2 class="sec-title">Explore our best recently <br/>completed project</h2>                  
                    </div>
                    <div class="work-showcase-container">
                        <div class="inner-box position-relative">
                            <div class="left-box">
                                <h1>01 <span>/</span></h1>
                                <h4><a href="projects.html">40,000 sq. ft. Office Space – Pune</a> </h4>
                            </div>
                            <div class="right-box">
                                <p>Client: Physics Wallah (Unicorn EdTech Brand)</p>
                                <p>We secured a prime Grade-A commercial office space in Pune for Physics Wallah,<br/> enabling their strategic expansion into Maharashtra's education and tech corridor.</p>
                                <div class="btn-box">
                                    <a href="projects.html"><i class="fat fa-arrow-right-long"></i></a>
                                </div>
                            </div>
                            <figure class="image z-1">
                                <img src="assets/img/resources/showcase-1.jpg" alt=""/>
                            </figure>
                        </div>
                        <div class="inner-box position-relative">
                            <div class="left-box">
                                <h1>02 <span>/</span></h1>
                                <h4><a href="projects.html">30,000 sq. ft. Standalone Retail Property – Maharashtra</a> </h4>
                            </div>
                            <div class="right-box">
                                <p>Client: Leading South Indian Apparel Chain</p>
                                <p>Executed multiple retail space acquisitions across Maharashtra for a pioneering apparel brand from South India. The highlight: a 30,000 sq. ft. standalone unit in a high-footfall commercial zone.</p>
                                <div class="btn-box">
                                    <a href="projects.html"><i class="fat fa-arrow-right-long"></i></a>
                                </div>
                            </div>
                            <figure class="image z-1">
                                <img src="assets/img/resources/showcase-1.jpg" alt=""/>
                            </figure>
                        </div>
                        <div class="inner-box position-relative">
                            <div class="left-box">
                                <h1>03 <span>/</span></h1>
                                <h4><a href="projects.html">10,000 sq. ft. Co-working Space – Baner, Pune</a> </h4>
                            </div>
                            <div class="right-box">
                                <p>Client: Regus – Global Co-working Brand</p>
                                <p>Identified and secured a plug-and-play commercial property in Pune’s IT hub (Baner) to set up a co-working center for Regus, ensuring seamless access to tech startups and corporates.
                                </p>
                                <div class="btn-box">
                                    <a href="projects.html"><i class="fat fa-arrow-right-long"></i></a>
                                </div>
                            </div>
                            <figure class="image z-1">
                                <img src="assets/img/resources/showcase-1.jpg" alt=""/>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
            <section class="connect-section">
                <div class="container-fluid">
                    <div class="row g-0">
                        <div class="col-lg-6 col-md-12">
                            <figure class="image">
                                <img src="assets/img/resources/conncet-1.jpg" alt=""/>
                            </figure>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <div class="connect-content-box">
                                <div class="title-box position-relative">
                                    <div class="title-shape" style={{backgroundImage:`url('assets/img/shape/title-shape.png')`}}></div>
                                    <h4 class="sec-sub-title">Driving Retail Expansion Across India</h4>
                                    <h2 class="sec-title"></h2>                  
                                </div>
                                <p>Connecting brands with the right space, at the right time — powered by real estate intelligence and strong local partnerships.</p>
                                <div class="progress-inner">
                                    <div class="progress-box">
                                        <p>High-Footfall Locations Covered</p>
                                        <div class="bar">
                                            <div class="bar-inner count-bar counted" data-percent="75%"></div>
                                            <div class="count-text">75+</div>
                                        </div>
                                    </div>
                                    <div class="progress-box">
                                        <p>Brand Partnerships Enabled</p>
                                        <div class="bar">
                                            <div class="bar-inner count-bar counted" data-percent="50%"></div>
                                            <div class="count-text">50+</div>
                                        </div>
                                    </div>
                                    <div class="progress-box">
                                        <p>Deals Closed Across India</p>
                                        <div class="bar">
                                            <div class="bar-inner count-bar counted" data-percent="100%"></div>
                                            <div class="count-text">150+</div>
                                        </div>
                                    </div>
                                    <div class="progress-box">
                                        <p>Legal Closures & Renewals Managed</p>
                                        <div class="bar">
                                            <div class="bar-inner count-bar counted" data-percent="120%"></div>
                                            <div class="count-text">120+</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 order-lg-0 order-first">
                            <div class="connect-content-box-two position-relative">
                                <div class="title-box position-relative">
                                    <div class="title-shape" style={{backgroundImage:`url('assets/img/shape/title-shape.png')`}}></div>
                                    <h4 class="sec-sub-title">What Makes GRSpaces Unique</h4>
                                    <h2 class="sec-title">Crafting Long-Term Success for Retail Brands</h2>                  
                                </div>
                                <p class="mb-4">Strategic Market Analysis: Deep insights into rental trends, footfall, and competitor mapping to help brands make data-driven expansion decisions.</p>
                                <p class="connect-text-2">Franchise Growth Enablement: Strong relationships with mall operators, local brokers, and landlords to speed up your multi-location rollouts.</p>
                                <p class="connect-text-2">Full-Cycle Real Estate Partner: From first site tour to post-opening support, we’re with you every step of the way.</p>
                                <div class="progress-circle">
                                    <div class="diagram">
                                        <img src="assets/img/shape/diagram.png" alt=""/>
                                    </div>
                                    <div class="diagram-list">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 order-lg-1 order-last">
                            <figure class="image">
                                <img src="assets/img/resources/conncet-2.jpg" alt=""/>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <Footer/>
      </>
  );
};
